<script lang="ts">
  import type { LoadingSpinnerSize, LoadingSpinnerTheme } from '.';

  export let theme: LoadingSpinnerTheme = 'brand';
  export let size: LoadingSpinnerSize = 'sm';
  let className = '';
  export { className as class };

  const themeClasses = {
    dark: 'text-ondark-primary',
    light: 'text-onlight-primary',
    brand: 'text-action-ondark-base'
  };

  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-10 h-10'
  };
  const sizeStrokeWidths = {
    sm: '1.5px',
    md: '1.5px',
    lg: '1px'
  };
</script>

<svg
  class="{className} {sizeClasses[size]} {themeClasses[theme]} animate-spin"
  viewBox="0 0 12 12"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M9.08588 10.2473C8.4156 10.7343 7.63959 11.0558 6.82128 11.1854C6.00298 11.315 5.16562 11.2491 4.37766 10.993C3.58971 10.737 2.87353 10.2982 2.28769 9.71231C1.70185 9.12647 1.26298 8.41029 1.00695 7.62234C0.750931 6.83438 0.685029 5.99702 0.814636 5.17872C0.944243 4.36041 1.26568 3.5844 1.75266 2.91412C2.23964 2.24385 2.87835 1.69835 3.61655 1.32221C4.35475 0.946079 5.1715 0.749996 6 0.749996"
    stroke="currentColor"
    stroke-width={sizeStrokeWidths[size]}
  />
</svg>

<style>
  path {
    stroke-dasharray: 20;
    animation: stretch 1.1s ease-in-out infinite;
  }
  @keyframes stretch {
    0% {
      stroke-dasharray: 20;
    }
    50% {
      stroke-dasharray: 14;
    }
    100% {
      stroke-dasharray: 20;
    }
  }
</style>
